export default function isPropControlled(prop) {
  return prop !== undefined;
}
//# sourceMappingURL=isPropControlled.js.map